import { isTryOnMobile, loadScriptOnIntent } from '../../../scripts/utils/utils';
import { applyFitmixDisclaimerParams } from './fitmix-disclaimer';

const fitmixTryOnContainer = document.getElementById('fitmix-container');
const tryonTemplateContainer = document.querySelector('[data-section-type="try-on-template"]');
const firstGlasses = tryonTemplateContainer?.querySelector('.to-glasses-wrapper[data-frame-id]');
let frameIdTryOn = firstGlasses?.dataset?.frameId;

// Early exit if try-on feature is not present on this page
if (!fitmixTryOnContainer || !frameIdTryOn) return;

const langTryOn = tryonTemplateContainer?.dataset?.lang;

let paramsTryOn = {
  apiKey: 'FKKyiL0aNESWKAlx1UDeYGlJY6Yw6RQ2o7J7pjXt',
  lang: langTryOn ? langTryOn : 'en',
  liveAutostart: false,
  mode: 'live',
  frame: frameIdTryOn,
  watermark: false,
  uiConfiguration: {
    liveRelaunchDetectionButton: false,
    livePhotoButton: false,
  },
};

applyFitmixDisclaimerParams(paramsTryOn, { container: tryonTemplateContainer });

let isInitializing = false;
let fitmixInstance = null;

async function initFitMix() {
  if (isInitializing || fitmixInstance) return;
  isInitializing = true;

  try {
    await loadScriptOnIntent('https://vto-advanced-integration-api.fittingbox.com/index.js', fitmixTryOnContainer, {
      mobile: 'immediate',
      desktop: 'immediate',
      idleTimeout: 5000,
      checkGlobal: 'FitMix',
      sessionKey: 'fitmix_interaction',
    });

    fitmixInstance = FitMix.createWidget('fitmix-container', paramsTryOn, onFitMixReady);
  } catch (error) {
    console.error('FitMix Init Error:', error);
    isInitializing = false;
  }
}

function onFitMixReady() {
  openVto();
}

function openVto() {
  sessionStorage.setItem('fitmix_interaction', 'true');
  fitmixInstance.startVto('live');
  fitmixTryOnContainer.style.display = 'block';

  const chatBox = document.querySelector('.woot--bubble-holder');
  if (chatBox) chatBox.style.display = 'none';
}

function initGlassesEvents() {
  const allGlasses = tryonTemplateContainer?.querySelectorAll('.to-glasses-wrapper[data-frame-id]');
  const allConnectedProducts = tryonTemplateContainer?.querySelectorAll('.to-connected-product[data-frame-id]');

  setChangeFrameEvents(allGlasses, false);
  setChangeFrameEvents(allConnectedProducts, true);
}

function setChangeFrameEvents(frames, showOnMobile = true) {
  frames.forEach((frame) => {
    const frameId = frame.dataset?.frameId;
    if (!frameId) return;

    frame.addEventListener('click', (e) => {
      e.stopPropagation();
      if (!(isTryOnMobile() && !showOnMobile)) handleSelection(frame);
    });
  });
}

function setFrame(targetEl) {
  if (targetEl.classList.contains('to-connected-product')) {
    handleSelection(targetEl);
  } else {
    const targetElIsWrapper = targetEl.classList.contains('to-glasses-wrapper');
    const glassesWrapper = targetElIsWrapper ? targetEl : targetEl.closest('.to-glasses-wrapper');
    const tempSelFrame = glassesWrapper.querySelector('.to-connected-product.to-default-cp');
    if (tempSelFrame) handleSelection(tempSelFrame);
  }
}

function highlightFrameUI(newSelectedFrame) {
  const oldSelectedFrame = tryonTemplateContainer?.querySelector('.selected-frame');
  const isWrapper = newSelectedFrame.classList.contains('to-glasses-wrapper');

  if (oldSelectedFrame) oldSelectedFrame?.classList.remove('selected-frame');
  if (isWrapper) newSelectedFrame = newSelectedFrame.querySelector('.to-default-cp');

  newSelectedFrame?.classList.add('selected-frame');

  const frameSelectedEvent = new CustomEvent('try-on:frame-selected');
  setTimeout(() => document.dispatchEvent(frameSelectedEvent));

  return newSelectedFrame;
}

function handleSelection(targetElement) {
  const selectedElement = highlightFrameUI(targetElement);
  const frameId = selectedElement.dataset.frameId;

  if (!fitmixInstance) {
    paramsTryOn.frame = frameId;
    initFitMix();
  } else {
    fitmixInstance?.setFrame(frameId);
  }
}

function selectInitialFrame() {
  let selectInitialFrame;

  if (isTryOnMobile()) {
    selectInitialFrame = tryonTemplateContainer?.querySelector('.to-connected-product.is-selected:not(.to-cp-not-available');
  } else {
    selectInitialFrame = tryonTemplateContainer?.querySelector('.to-connected-product:not(.to-cp-not-available');
  }

  if (!selectInitialFrame) return;
  highlightFrameUI(selectInitialFrame);
}

setTimeout(selectInitialFrame);
initGlassesEvents();

document.addEventListener('try-on:loaded-glasses', () => setTimeout(initGlassesEvents));
document.addEventListener('try-on:frame-changed', (e) => {
  const selectedGlasses = e.detail.selectedGlasses;
  if (selectedGlasses) setFrame(selectedGlasses);
});

const isProductPage = window.location.pathname.includes('/products/');

if (!isProductPage) {
  initFitMix();
}
